import {MatTableDataSource} from '@angular/material/table';
import {Component as GtComponent, Response, ServiceAdministrationService} from '@gt-api';
import {TableEntry} from './table-entry';

export abstract class GenericTableRowActions<T extends TableEntry<T1>, T1, T2 extends TableEntry<T1>> {
  dataSource = new MatTableDataSource<T>();
  guiDataSource = new MatTableDataSource<T2>();
  isSaveSuccess: boolean = null;

  protected constructor(protected entriesFieldName: string) {}

  addRow() {
    const newModelEntry = this.newModelEntry();
    const entry = this.newTableEntry(newModelEntry, true, true);
    const data = this.guiDataSource.data.slice();
    data.push(entry);
    this.guiDataSource.data = data;
    this.updateComponentEntries();
  }

  deleteRow(row: T2) {
    const data = this.guiDataSource.data.slice();
    const index = data.indexOf(row);
    data.splice(index, 1);
    this.guiDataSource.data = data;

    // We don't need to copy this array, because it is not updated on GUI
    const dataSourceIndex = this.findSameEntryIndex(row);
    this.dataSource.data.splice(dataSourceIndex, 1);

    this.updateComponentEntries();
    this.save();
  }

  cancelRow(row: T2, isNew = false) {
    const data = this.guiDataSource.data.slice();
    const index = data.indexOf(row);
    if (isNew) {
      data.splice(index, 1);
    } else {
      data[index] = this.newTableEntry(row.entry, false, false);
    }
    this.guiDataSource.data = data;
  }

  saveModule(service: ServiceAdministrationService, oname: string, login: string) {
    const module = this.getModule();
    service.editComponent1(module.serviceNumber, module.id, oname, login, module).subscribe(
      (response: Response) => {
        this.isSaveSuccess = response.code === 200;
      },
      error => {
        console.log('save module error:', error);
        this.isSaveSuccess = false;
      },
      () => setTimeout(() => (this.isSaveSuccess = null), 5000)
    );
  }

  updateComponentEntries(): void {
    const component = this.getModule();
    component[this.entriesFieldName] = this.dataSource.data.map(e => e.entry);
  }

  abstract save();

  abstract saveRow(entry: T2): void;

  abstract newTableEntry(entry: T1, editing: boolean, isNew: boolean): T2;

  abstract newModelEntry(): T1;

  abstract getModule(): GtComponent;

  abstract findSameEntryIndex(row: T2);
}
